// Although it states "bedrijfsdata" here, NormalModuleReplacementPlugin will replace it with the correct file based on VUE_APP_TYPE.
const router = require('@/router/bedrijfsdata').default;
export default router;